export const LOCAL_STORAGE_KEY = "SUNDAESWAP_GOVERNANCE_LOCAL_CACHE";
export const LOCAL_CHECK_VOTE_SIG = "SUNDAESWAP_GOVERNANCE_LOCAL_CHECK_VOTE_SIG";
export const DAY_EXPIRES = 7;
//# sourceMappingURL=localStorage.js.map